import { useTranslation } from 'react-i18next';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { StoreEmployee } from '@/models/storeModel';

interface ConfirmRoleChangeDialogProps {
  employee: StoreEmployee;
  newRole: string;
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onConfirm: () => void;
}

export function ConfirmRoleChangeDialog({
  employee,
  newRole,
  open,
  onOpenChange,
  onConfirm,
}: ConfirmRoleChangeDialogProps) {
  const { t } = useTranslation();

  const formatRole = (role: string) => {
    return role.charAt(0).toUpperCase() + role.slice(1).replace('_', ' ');
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>{t('confirmRoleChange')}</DialogTitle>
          <DialogDescription>
            {t('confirmRoleChangeDescription', {
              employee,
              currentRole: formatRole(employee.role),
              newRole: formatRole(newRole),
            })}
          </DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <Button variant='outline' onClick={() => onOpenChange(false)}>
            {t('cancel')}
          </Button>
          <Button onClick={onConfirm}>{t('confirm')}</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
